import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Tailoring.css";
import { LogIn } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import { useRef } from "react";
const ApproveCertificate = () => {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState(""); 
  const [viewdatas, setViewdatas] = useState(null);
  const [view, setView] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [resubmit,setResubmit]=useState(false);
  const [approve,setApprove]=useState(false)
  
  const recordsPerPage = 20;
 const [approvefile, setApprovefile] = useState(null);

  const [inputValue, setInputValue] = useState("");


   const navi =useNavigate()
   useEffect(() => {
    const role = localStorage.getItem("userRole");
    if (role !== "supperadmin") {
      // alert("Access denied. You do not have permission to view this page.");
      navi("/"); // redirect to home or login page
    }
  }, [navi]);
  // Handle input change
  const handleChangeResubmit = (event) => {
    setInputValue(event.target.value);
  };

  const handleUpdateSubmit = async (id,inputValue ) => {
    if (inputValue===""){
      alert("Please enter a value before submitting.");
         return;
      
    }
  
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API}/tailoring/updateapprove/${id}`,
        { description: inputValue,status: "Re Submit"}
      );
  
      if (response.status === 200) {
        alert("User description updated successfully!");
        setInputValue('')
        fetchUsers();
        setView(false);
      }
    } catch (error) {
      console.error("Error updating user:", error);
      alert("Error updating user.");
    }
  };
  
  

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API}/tailoring/getUsers`);
      const filterdata = response.data.filter(
        (user) => user.status === "Pending" && user.description === null
      );

     
      setUsers(filterdata);
  
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const handleResubmit = (id) => {
    setResubmit(!resubmit)
  };

  const handleView = async (id) => {
    try {
      const getvalue = await axios.get(`${process.env.REACT_APP_API}/tailoring/getuser/${id}`);
      setViewdatas(getvalue.data);
      // console.log('bvhbb',getvalue.data)
      setView(true);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };


  const handleUpdate = async (id, approvefile) => {
    if (!approvefile) {
      alert("Please select a PDF file before submitting.");
      return;
    }
    //  console.log(approvefile);
    const formData = new FormData();
    formData.append("approveFile", approvefile);
    formData.append("status", "Approved");
   
    try {
      
      
      const response = await axios.put(
        `${process.env.REACT_APP_API}/tailoring/updateapprove/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.status === 200) {
        alert("User status and certificate uploaded successfully!");
        fetchUsers();
        setView(false);
        setApprove(false);
        setApprovefile(null);
      }
    } catch (error) {
      console.error("Error updating user:", error);
      alert("Error updating user.");
    }
  };
  // Filter data based on search input
  const filteredData = users.filter((user) =>
    user.name.toLowerCase().includes(search.toLowerCase())
  );

  // Calculate total pages
  const totalPages = Math.ceil(filteredData.length / recordsPerPage);

  // Get users for current page
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredData.slice(indexOfFirstRecord, indexOfLastRecord);
    



  const qrRef = useRef(null); // declare this inside the component
const handleQRDownload = () => {
  const container = qrRef.current;
  if (!container) {
    alert("QR container not found.");
    return;
  }

  const svgElement = container.querySelector("svg");
  if (!svgElement) {
    alert("QR code SVG not found.");
    return;
  }

  const svgData = new XMLSerializer().serializeToString(svgElement);
  const svgBlob = new Blob([svgData], { type: "image/svg+xml;charset=utf-8" });
  const url = URL.createObjectURL(svgBlob);

  const qrImage = new Image();
  qrImage.onload = () => {
    const qrSize = 256; // must match QRCodeSVG size
    const canvas = document.createElement("canvas");
    canvas.width = qrSize;
    canvas.height = qrSize;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(qrImage, 0, 0, qrSize, qrSize);

    // ✅ Load and draw logo at center
    const logo = new Image();
    logo.src = "/assets/logo.png"; // same path you used in imageSettings
    logo.onload = () => {
      const logoSize = qrSize * 0.15; // 20% of QR size
      const x = (qrSize - logoSize) / 2;
      const y = (qrSize - logoSize) / 2;
      ctx.drawImage(logo, x, y, logoSize, logoSize);

      const pngFile = canvas.toDataURL("image/png");

      const link = document.createElement("a");
      link.download = `QR-${viewdatas?.name || "user"}.png`;
      link.href = pngFile;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(url);
    };
  };

  qrImage.src = url;
};



  return (
    <div className="approve-certificate-container">
      <div className="approve-certificate-wrapper">
        <h2 className="text-center">Approve Certificate</h2>
        <input
          className="search-input"
          type="text"
          placeholder="Search by name"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <table>
          <thead>
            <tr>
              <th>S No</th>
              <th>Name</th>
              <th>Course Name</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {currentRecords.map((user, index) => (
              <tr key={user.id}>
                <td>{indexOfFirstRecord + index + 1}</td>
                <td>{user.name}</td>
                <td>{user.courseName}</td>
                <td className="status" >{user.status || "Pending"}</td>
                <td className="action-buttons">
                  {/* <button className="approved-btn" onClick={() => handleUpdate(user.id, user.status)} style={{marginRight:'5px'}}>
                    Approve
                  </button> */}
                  <button className="view-btn" onClick={() => handleView(user.id)}>
                       service status
                  </button>
                  {/* <button className="resubmit-btn" onClick={() => handleResubmit(user.id)}>
                    Resubmit
                  </button> */}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Pagination Controls */}
        <div className="pagination-controls">
          <button onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>
          <span>Page {currentPage} of {totalPages}</span>
          <button onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === totalPages}>
            Next
          </button>
          
        </div>
      </div>

{view && (
  <div className="approve_certificate-overlay">
    <div className="approve_certificate-popup">
      <div className="approve_certificate-popup-header">
        <h2 className="approve_certificate-title">
          View Tailoring User
        </h2>
        <button className="approve_certificate-close-btn" onClick={() => setView(false)}>X</button>
      </div>

      <div className="approve_certificate-popup-body">
        <div className="approve_certificate-view-grid">
          <div className="approve_certificate-view-item">
            <strong>Name:</strong> <input readOnly value={viewdatas?.name || ''} />
          </div>
          <div className="approve_certificate-view-item">
            <strong>Relationship:</strong> <input readOnly value={viewdatas?.relationship || ''} />
          </div>
          <div className="approve_certificate-view-item">
            <strong>Father/Husband Name:</strong> <input readOnly value={viewdatas?.fatherHusbandName || ''} />
          </div>
          <div className="approve_certificate-view-item">
            <strong>Door Number:</strong> <input readOnly value={viewdatas?.doorNumber || ''} />
          </div>
          <div className="approve_certificate-view-item">
            <strong>Street Name:</strong> <input readOnly value={viewdatas?.streetName || ''} />
          </div>
          <div className="approve_certificate-view-item">
            <strong>Postal Area:</strong> <input readOnly value={viewdatas?.postalArea || ''} />
          </div>
          <div className="approve_certificate-view-item">
            <strong>District:</strong> <input readOnly value={viewdatas?.district || ''} />
          </div>
          <div className="approve_certificate-view-item">
            <strong>Taluk:</strong> <input readOnly value={viewdatas?.taluk || ''} />
          </div>
          <div className="approve_certificate-view-item">
            <strong>Pin Code:</strong> <input readOnly value={viewdatas?.pinCode || ''} />
          </div>
          <div className="approve_certificate-view-item">
            <strong>Aadhar Number:</strong> <input readOnly value={viewdatas?.aadharNumber || ''} />
          </div>
            <div className="approve_certificate-view-item">
            <strong>institutionName:</strong> <input readOnly value={viewdatas?.institutionName || ''} />
          </div>
          <div className="approve_certificate-view-item">
            <strong>Course Name:</strong> <input readOnly value={viewdatas?.courseName || ''} />
          </div>
          <div className="approve_certificate-view-item">
            <strong>Center At:</strong> <input readOnly value={viewdatas?.center_location || ''} />
          </div>
          <div className="approve_certificate-view-item">
            <strong>Photo:</strong><br />
            {viewdatas?.photo ? (
              <img
                src={`${process.env.REACT_APP_API}/uploads/Categories/${viewdatas?.photo}`}
                alt="User"
                className="approve_certificate-user-photo"
              />
            ) : (
              "No Photo Available"
            )}
          </div>
        <div className="approve_certificate-view-item">
  <strong>QR:</strong><br />

  <div ref={qrRef}>
    <QRCodeSVG
      value={`${process.env.REACT_APP_API}/uploads/Categories/${viewdatas.photo}`}
      size={156}
      imageSettings={{
        src: "/assets/logo.png",
        height: 30,
        width: 30,
        excavate: true,
      }}
    />
  </div>
  <a onClick={handleQRDownload} style={{cursor:'pointer'}}>Download QR</a>
  {/* <button onClick={handleQRDownload}>Download QR</button> */}
</div>

          <div className="approve_certificate-view-item">
            <strong>Signature Photo:</strong><br />
            {viewdatas?.Signature_Photo ? (
              <img
                src={`${process.env.REACT_APP_API}/Uploads/institution/${viewdatas?.Signature_Photo}`}
                alt="Signature"
                className="approve_certificate-user-photo"
              />
            ) : (
              "No Photo Available"
            )}
          </div>
          
        </div>
      </div>

      {resubmit && (
        <div className="approve_certificate-resubmit-div show">
          <input
            type="text"
            value={inputValue}
            onChange={handleChangeResubmit}
            placeholder="Enter text..."
          />
          <button onClick={() => handleUpdateSubmit(viewdatas.id, inputValue)}>Submit</button>
        </div>
      )}

      {approve && (
        <div className="approve_certificate-resubmit-div show">
          <input
            type="file"
            accept="application/pdf"
            onChange={(e) => setApprovefile(e.target.files[0])}
            className="approve_certificate-input-style"
          />
          <button onClick={() => handleUpdate(viewdatas.id, approvefile)}>Submit</button>
        </div>
      )}

      <div className="approve_certificate-popup-footer">
        <button
          className="approve_certificate-approved-btn"
          onClick={() => setApprove(!approve)}
        >
          Approve
        </button>
        <button
          className="approve_certificate-resubmit-btn"
          onClick={() => handleResubmit(viewdatas.id)}
        >
          Resubmit
        </button>
        <button className="approve_certificate-close-btn" onClick={() => setView(false)}>Close</button>
      </div>
    </div>
  </div>
)}


    </div>
  );
};

export default ApproveCertificate;
